angular.module('picmonicng').controller('FindPicmonicController', [
  '$scope',
  '$stateParams',
  '$cookies',
  'UserService',
  'MarketOptionsConfig',
  'MarketSelectorModalService',
  '$rootScope',
  'Picmonics',
  'User',
  '$filter',
  'BrowseService',
  '$state',
  'FreePremiumTrialModal',
  'SplitTestService',
  '$http',
  function (
    $scope,
    $stateParams,
    $cookies,
    UserService,
    MarketOptionsConfig,
    MarketSelectorModalService,
    $rootScope,
    Picmonics,
    User,
    $filter,
    BrowseService,
    $state,
    FreePremiumTrialModal,
    SplitTestService,
    $http
  ) {
    $scope.base_asset_url = $rootScope.base_asset_url;
    $scope.searching = false;
    $scope.searchOpen = false;

    if (UserService.user.user_id) {
      $http.get('/api/v3/playlists/trial-playlist/picmonics').then(function (response) {
        $scope.cards = response.data;
      });
    }

    if (UserService.user.lead) {
      $scope.market = MarketOptionsConfig.getMarketById(UserService.user.lead);
    } else if ($stateParams.market) {
      $scope.market = MarketOptionsConfig.getMarketBySlug($stateParams.market);
    } else if ($cookies.get('pls_user_lead')) {
      $scope.market = MarketOptionsConfig.getMarketById($cookies.get('pls_user_lead'));
    } else {
      MarketSelectorModalService.showMarketSelectorModal();
    }

    if (UserService.user.user_id && UserService.user.lead && !UserService.user.tos_accepted) {
      UserService.showTOSModal();
    }

    if (UserService.user.premium_trial_eligible && UserService.user.role !== 'Professor') {
        FreePremiumTrialModal.show();
    }

    if ($scope.market) {
      var occupationName = MarketOptionsConfig.getMarketById($scope.market.id).occupation_name;

      if (occupationName) {
        switch (occupationName[0]) {
          case 'a':
          case 'e':
          case 'i':
          case 'o':
          case 'u':
            $scope.occupation_name = 'an ' + occupationName;
            break;
          default:
            $scope.occupation_name = 'a ' + occupationName;
            break;
        }
      }

      if (
        UserService.user.school &&
        UserService.user.school.name &&
        UserService.user.school.name.indexOf('Other') !== 0
      ) {
        if (UserService.user.school.abbreviation) {
          $scope.school_name = ' at ' + UserService.user.school.abbreviation;
        } else {
          $scope.school_name = ' at ' + UserService.user.school.name;
        }
      }
    }

    $scope.$emit('endInteraction');

    $scope.clickRecommendation = function (picmonic) {
      if (typeof atlasEvent !== 'undefined') {
        atlasEvent('click', 'find-picmonic launch first_recommendations_picmonic ' + picmonic.card_id);
      }

      $state.go('app.learn', { slug: picmonic.slug });
    };

    $scope.clickRecommendationTrack = function (track) {
      if (typeof atlasEvent !== 'undefined') {
        atlasEvent('click', 'find-picmonic launch first_recommendations_track ' + track.track_id);
      }
    };

    if ($scope.market) {
      UserService.setMarketCookies($scope.market.id);
    }

    $scope.stats = User.get({ resource: 'stats' });

    $scope.search = function () {
      $scope.searching = true;

      $scope.results = Picmonics.search({
        source: 'find-picmonic',
        query: $scope.searchTerm,
        page: 1,
        searchPicmonics: true,
        searchPathways: true,
        searchBreadcrumbs: true,
        sort_by: 'relevance',
        include_ugc: false,
        quick: 1,
      });

      $scope.results.$promise.finally(function () {
        $scope.searching = false;
        $scope.searchOpen = true;
      });
    };

    $scope.goToPathway = function (pathway) {
      BrowseService.go(
        'app.pathways.market.' + pathway.root_pathway_type + '.tracks' + (pathway.track_id ? '.picmonics' : ''),
        {
          curriculum: pathway.root_curriculum,
          market: MarketOptionsConfig.getMarketById(pathway.market_id).slug,
          pathway_id: pathway.root_pathway_id,
          track_id: pathway.track_id,
          scroll_to: pathway.further_sub_pathway_id ? pathway.further_sub_pathway_id : pathway.sub_pathway_id,
        }
      );
    };

    $scope.generateBreadCrumbs = function (item) {
      var buffer = '';
      var arrow_right = ' &rsaquo; ';
      var title = item.name;

      if (item.root_pathway_type) {
        var found = false;
        angular.forEach($scope.market.sections, function (section) {
          if (section.pathway_type == item.root_pathway_type && section.curriculum == item.root_curriculum && !found) {
            buffer += $filter('ucfirst')(section.name);
            found = true;
          }
        });
      }

      if (item.root_name && item.root_name != title) {
        if (buffer.length) {
          buffer += arrow_right;
        }
        buffer += item.root_name;
      }

      if (item.sub_pathway_name && item.sub_pathway_name != title) {
        if (buffer.length) {
          buffer += arrow_right;
        }
        buffer += item.sub_pathway_name;
      }

      if (item.further_sub_pathway_name && item.further_sub_pathway_name != title) {
        if (buffer.length) {
          buffer += arrow_right;
        }
        buffer += item.further_sub_pathway_name;
      }

      return buffer;
    };

    $scope.getExamName = function (exam) {
      var sections = $filter('filter')($scope.market.sections, {
        curriculum: exam.exam,
      });
      if (sections.length) {
        return sections[0].name;
      } else {
        return exam.exam.replace('-', ' ').ucwords();
      }
    };

    $scope.goToExam = function (exam) {
      BrowseService.go('home', {
        visible_content: 'boards_' + exam.curriculum,
      });
    };

    // SEO Shortcut to open pathways and paths
    if (
      $stateParams.pathway_type &&
      $stateParams.curriculum &&
      (!UserService.user.user_id || (UserService.user.user_id && UserService.user.lead == $scope.market.id))
    ) {
      BrowseService.go('home', {
        market: $scope.market.slug,
        pathway_type: $stateParams.pathway_type,
        curriculum: $stateParams.curriculum,
      });
    } else if (
      $stateParams.path &&
      (!UserService.user.user_id || (UserService.user.user_id && UserService.user.lead == $scope.market.id))
    ) {
      BrowseService.go('app.pathways.market.courses.tracks.picmonics', {
        market: $scope.market.slug,
        pathway_id: $stateParams.pathway,
        track_id: $stateParams.path,
      });
    } else if (
      $stateParams.pathway &&
      (!UserService.user.user_id || (UserService.user.user_id && UserService.user.lead == $scope.market.id))
    ) {
      BrowseService.go('app.pathways.market.courses.tracks', {
        market: $scope.market.slug,
        pathway_id: $stateParams.pathway,
      });
    }
  },
]);
